import React, { FC, useState, Fragment } from "react";
import PropTypes from "prop-types";

import List from "@material-ui/core/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";

import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";

import SideNavItemComponent from "./SideNavItemComponent";

export const SideNavItemPropTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string,
  Icon: PropTypes.elementType,
  items: PropTypes.array
};

// TypeScript compile-time props type, inferred from propTypes
// https://dev.to/busypeoples/notes-on-typescript-inferring-react-proptypes-1g88
type SideNavItemPropTypes = PropTypes.InferProps<typeof SideNavItemPropTypes>;
type SideNavItemPropsWithoutItems = Omit<SideNavItemPropTypes, "items">;

// Improve child items declaration
export type SideNavItemProps = SideNavItemPropsWithoutItems & {
  items?: SideNavItemProps[];
};

const SideNavItem: FC<SideNavItemProps> = props => {
  const { name, link, Icon, items = [] } = props;
  const isExpandable = items && items.length > 0;
  const [open, setOpen] = useState(false);

  const MenuItemRoot = (
    <SideNavItemComponent link={link} onClick={() => setOpen(!open)}>
      {!!Icon && (
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
      )}
      <ListItemText primary={name} inset={!Icon} />
      {isExpandable && !open && <IconExpandMore />}
      {isExpandable && open && <IconExpandLess />}
    </SideNavItemComponent>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {items.map((item, index) => (
          <SideNavItem {...item} key={index} />
        ))}
      </List>
    </Collapse>
  ) : null;

  return (
    <Fragment>
      {MenuItemRoot}
      {MenuItemChildren}
    </Fragment>
  );
};

export default SideNavItem;
